import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getUploadAuditOverview = ({ version = 'v2' } = {}) =>
  client
    .request({
      url: `${version}/data-process/upload-audit/overview/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getUploadAuditList = ({ version = 'v2', params = {} } = {}) =>
  client
    .request({
      url: `${version}/data-process/upload-audit/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSFTPCredentials = ({ version = 'v2', params = {} } = {}) =>
  client
    .request({
      url: `${version}/data-process/sftp-credentials/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getIdentifierCoverage = ({ version = 'v2', params = {} } = {}) =>
  client
    .request({
      url: `${version}/data-process/context/identifier-coverage/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createNewUpload = ({
  version = 'v2',
  params = {},
  data = {},
} = {}) =>
  client
    .request({
      url: `${version}/data-process/data-task/`,
      method: RequestMethod.POST,
      params,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getUploadDetail = ({
  version = 'v2',
  params = {},
  uploadId,
} = {}) =>
  client
    .request({
      url: `${version}/data-process/data-task/${uploadId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const downloadTemplate = ({
  version = 'v2',
  params = {},
  uploadId,
} = {}) =>
  client
    .request({
      url: `${version}/data-process/data-task/${uploadId}/template/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const commonUpload = ({ version = 'v1', params = {}, data = {} } = {}) =>
  client
    .request({
      url: `${version}/common/upload/`,
      method: RequestMethod.POST,
      params,
      data,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const requestRun = ({
  version = 'v2',
  params = {},
  runType = '',
  uploadId,
} = {}) =>
  client
    .request({
      url: `${version}/data-process/data-task/${uploadId}/run/`,
      method: RequestMethod.POST,
      params,
      data: { runType },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const logBundleDownload = ({
  version = 'v2',
  params = {},
  logType,
  runId,
} = {}) =>
  client
    .request({
      url: `${version}/data-process/data-task-run/${runId}/logs/${logType}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const modifyUpload = ({
  version = 'v2',
  params = {},
  payload,
  uploadId,
} = {}) =>
  client
    .request({
      url: `${version}/data-process/data-task/${uploadId}/`,
      method: RequestMethod.PATCH,
      params,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createValidationRun = ({
  version = 'v2',
  params = {},
  data = {},
} = {}) =>
  client
    .request({
      url: `${version}/data-process/validation-run/`,
      method: RequestMethod.POST,
      params,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getValidationRunList = ({ version = 'v2', params = {} } = {}) =>
  client
    .request({
      url: `${version}/data-process/validation-run/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getValidationRunDetails = ({ version = 'v2', id } = {}) =>
  client
    .request({
      url: `${version}/data-process/validation-run/${id}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
